export default __webpack_public_path__ + "images/bd9ea1e00cb78947cf1a46a3c3d00a78.png";